import { render, staticRenderFns } from "./Supply_bom.vue?vue&type=template&id=23307776&scoped=true"
import script from "./Supply_bom.vue?vue&type=script&lang=js"
export * from "./Supply_bom.vue?vue&type=script&lang=js"
import style0 from "./Supply_bom.vue?vue&type=style&index=0&id=23307776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23307776",
  null
  
)

export default component.exports